import { Device } from '../models/device'
import type { DeviceSample } from '../../DeviceSamples/models/deviceSample'

export interface DeviceStateType {
  devices: Device[]
  device: Device | null
  deviceMeasurements: Record<string, DeviceSample[]> // deviceId -> deviceSamples[]
  deviceLastMeasurement: Record<string, DeviceSample | null> // deviceId -> last deviceSample
}

const DeviceState: () => DeviceStateType = () => ({
  devices: [],
  device: null,
  deviceMeasurements: {},
  deviceLastMeasurement: {},
})

export default DeviceState
